import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useFormattedName = () => {
  const currentUserInfo = useSelector((state) => state.securityNew.currentUserInfo);

  const formattedName = useMemo(
    () =>
      currentUserInfo.name ||
      (currentUserInfo.firstName &&
        currentUserInfo.lastName &&
        `${currentUserInfo.firstName} ${currentUserInfo.lastName}`) ||
      currentUserInfo.username,
    [currentUserInfo.name, currentUserInfo.firstName, currentUserInfo.lastName, currentUserInfo.username],
  );

  return formattedName;
};

export default useFormattedName;
